import { DIMENSION_TEMPLATE, EMPTY_SHIPMENT, Piece, Shipment, MASTER_WAYBILL, HOUSE_WAYBILL, Company, COMPANY_TEMPLATE } from "../interfaces";
import { UserService } from "../services/user.service";
import { Wrapper } from "./wrapper";

export class ShipmentWrapper extends Wrapper {

  shipment = EMPTY_SHIPMENT;



  constructor(shipment: Shipment, userService: UserService) {
    super(shipment, shipment?.dimensions[0] || DIMENSION_TEMPLATE, userService);
    if (shipment) {
      this.shipment = shipment;
    }
  }

  get grossWeight(): string {
    return this.valueString(this.shipment.totalGrossWeight);
  }


  get pieceCount(): string {
    return this.shipment.totalPieceCount.toFixed(0);
  }

  get containedPieces(): Piece[] {
    return this.shipment.containedPieces;
  }

  get chargeableWeight(): string {
    return this.valueString(this.shipment.volumetricWeight?.[0].chargeableWeight);
  }

  private getAwb(type: string): string {
    let res = '';
    let waybill = this.shipment.waybillNumber;
    while (waybill && res === '') {
      if (waybill.waybillType === type) {
        res = `${waybill.waybillPrefix}${waybill.waybillNumber}`;
        break;
      }
      if (waybill.containedWaybills) {
        waybill = waybill.containedWaybills[0]; // FIX ME: visit not just the first one
      }
    }
    return res;
  }

  get masterAwb(): string {
    return this.getAwb(MASTER_WAYBILL);
  }

  get houseAwb(): string {
    return this.getAwb(HOUSE_WAYBILL);
  }

  private shipper(): Company {
    return this.shipment.parties.find(party => party.partyRole === 'shipper')?.partyDetails || COMPANY_TEMPLATE;
  }

  get client(): string {
    return this.shipper().companyName;
  }


  get forwarder(): string {
    const forwarder = this.shipment.parties.find(party => party.partyRole === 'forwarder')?.partyDetails || COMPANY_TEMPLATE;
    return forwarder.companyName;
  }

}
